export const LANG = {
  pt: "pt",
  en: "en"
} 